if (!customElements.get('text-truncate')) {
  customElements.define('text-truncate', class TextTruncate extends HTMLElement {
    connectedCallback() {
      this.maxHeightDesktop = parseInt(this.dataset.maxHeightDesktop) || 200;
      this.maxHeightMobile = parseInt(this.dataset.maxHeightMobile) || 200;
      this.maxLines = parseInt(this.dataset.maxLines) || 0;
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.moreText = this.dataset.moreText || 'Pokaż więcej';
      this.lessText = this.dataset.lessText || 'Pokaż mniej';
      this.buttonStyle = this.dataset.buttonStyle || 'link';
      this.buttonAlignment = this.dataset.buttonAlignment || 'left';
      this.expanded = false;
      this.content = this.firstElementChild;
      if (!this.content) return;
      this.maxHeight = this.computeMaxHeight();

      this._onBreakpointChange = () => this.handleBreakpointChange();
      this.mobileQuery.addEventListener('change', this._onBreakpointChange);

      requestAnimationFrame(() => this.init());
      this._resizeObserver = new ResizeObserver(() => this.checkHeight());
      this._resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
      if (this.mobileQuery && this._onBreakpointChange) {
        this.mobileQuery.removeEventListener('change', this._onBreakpointChange);
      }
    }

    computeMaxHeight() {
      if (this.maxLines > 0 && this.content) {
        const cs = window.getComputedStyle(this.content);
        let lineHeight = parseFloat(cs.lineHeight);
        if (isNaN(lineHeight)) {
          lineHeight = parseFloat(cs.fontSize) * 1.4;
        }
        return Math.ceil(lineHeight * this.maxLines);
      }
      return this.mobileQuery.matches ? this.maxHeightMobile : this.maxHeightDesktop;
    }

    handleBreakpointChange() {
      this.maxHeight = this.computeMaxHeight();
      if (!this.initialized) return;
      if (!this.expanded) {
        this.content.style.maxHeight = this.maxHeight + 'px';
      }
    }

    init() {
      const natural = this.content.scrollHeight;
      if (natural <= this.maxHeight) return;

      this.content.style.maxHeight = this.maxHeight + 'px';
      this.content.style.overflow = 'hidden';
      this.content.style.transition = 'max-height 0.4s ease';

      this.gradient = document.createElement('div');
      this.gradient.style.cssText = 'height:40px;margin-top:-40px;position:relative;background:linear-gradient(transparent, rgb(var(--color-background)));pointer-events:none;transition:opacity 0.3s;';
      this.content.after(this.gradient);

      this.btn = document.createElement('button');
      this.btn.type = 'button';
      this.btn.textContent = this.moreText;
      this.applyButtonStyle();
      this.btn.style.marginTop = 'var(--sp-4)';
      this.btn.style.display = 'block';
      if (this.buttonAlignment === 'center') {
        this.btn.style.marginInline = 'auto';
        this.btn.style.textAlign = 'center';
      } else if (this.buttonAlignment === 'right') {
        this.btn.style.marginInlineStart = 'auto';
        this.btn.style.textAlign = 'end';
      }
      this.btn.addEventListener('click', () => this.toggle());
      this.gradient.after(this.btn);
      this.initialized = true;
    }

    applyButtonStyle() {
      if (this.buttonStyle === 'link') {
        this.btn.className = 'link inline-block';
      } else if (this.buttonStyle === 'primary') {
        this.btn.className = 'button button--primary';
        this.btn.setAttribute('is', 'hover-button');
        this.btn.innerHTML = '<span class="btn-fill" data-fill></span><span class="btn-text">' + this.escapeHtml(this.moreText) + '</span>';
      } else {
        this.btn.className = 'button button--secondary';
        this.btn.setAttribute('is', 'hover-button');
        this.btn.innerHTML = '<span class="btn-fill" data-fill></span><span class="btn-text">' + this.escapeHtml(this.moreText) + '</span>';
      }
    }

    toggle() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
        this.gradient.style.opacity = '0';
        this.updateLabel(this.lessText);
      } else {
        this.content.style.maxHeight = this.maxHeight + 'px';
        this.gradient.style.opacity = '1';
        this.updateLabel(this.moreText);
      }
    }

    updateLabel(text) {
      if (this.buttonStyle === 'link') {
        this.btn.textContent = text;
      } else {
        const span = this.btn.querySelector('.btn-text');
        if (span) span.textContent = text;
      }
    }

    checkHeight() {
      if (!this.initialized) {
        const natural = this.content.scrollHeight;
        if (natural > this.maxHeight) this.init();
      }
    }

    escapeHtml(str) {
      const d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML;
    }
  });
}
